import { useLayoutEffect } from 'react'
import TenantBar from './TenantBar.jsx'
import UserBar from './UserBar.jsx'
import NotificationBar from './NotificationBar.jsx'
import LogoEchoSystem from '../components/ui/LogoEchoSystem.jsx'

const HeaderNavBar = ({companiesList, branchesList, tenantUsername, tenant, companySelected, branchSelected}) => {
    useLayoutEffect(() => {
        const headerElement = document.querySelector('.primary-bg-color.sticky');
        if (!headerElement) return;
        const update = () => {
            document.documentElement.style.setProperty('--header-height', `${headerElement.offsetHeight}px`);
        };
        update();
        requestAnimationFrame(update);
        const observer = new ResizeObserver(update);
        observer.observe(headerElement);
        return () => observer.disconnect();
    }, []);

    return (
        <div className='primary-bg-color sticky top-0 z-[100] text-white'>
            <NotificationBar />
            <div className="px-3 w-full">
                <div className='flex flex-row w-full py-1 items-center gap-4'>
                    
                    <div className='flex flex-1 items-center'>
                        <TenantBar 
                            companiesList={companiesList}
                            branchesList={branchesList}
                            companySelected={companySelected} 
                            branchSelected={branchSelected} />
                    </div>

                    <div className="shrink-0 flex items-center justify-center">
                        <LogoEchoSystem />
                    </div>

                    <div className="flex flex-1 items-center justify-end">
                        <UserBar
                            tenantUsername={tenantUsername}
                            tenant={tenant}
                        />
                    </div>

                </div> 
            </div>
        </div>
    )
}

export default  HeaderNavBar 
